<script>
    export let client;
    export let uid;
</script>

<div class="notification is-info">
    Omlouváme se, ale v tuto chvíli není možné provést platbu přes platební bránu.<br>
    Použijte jeden z alternativních způsobů níže:
</div>

<div class="notification">
    <b>Platba na účet</b><br>
    Číslo účtu: <b>1281052011/3030</b><br>
    Účel platby / poznámka pro příjemce:<br>
    <b>{client.cln_name},cvičení,{uid}</b>

    <p>
        <br>V případě, že chcete vystavit fakturu, odešlete email s fakturačními údaji a identifikátorem (<b>{uid}</b>) na <b>chytrypohyb@email.cz</b> a platbu zadejte dle instrukcí na faktuře.
    </p>
</div>

<div class="notification">
    <b>Platba v hotovosti</b><br>
    <!-- Platbu je možné provést přímo v hotovosti.<br> -->
    Pro více informací kontaktujte <b>Lindu Varnuškovou</b><br>
    <!-- tel.: <b>+420 723 773 360</b><br> -->
    email: <b>chytrypohyb@email.cz</b>
</div>